document.addEventListener('DOMContentLoaded', function () {
  var duration = 1500;
  var hasNumbers = /\d/;

  function animateValue(element) {
    var finalText = element.getAttribute('data-gaganyaan-stat-value');
    if (!finalText || !hasNumbers.test(finalText)) return;

    var parts = finalText.split(/(\d+)/);
    var numberParts = [];

    parts.forEach(function (part, index) {
      if (/^\d+$/.test(part)) {
        numberParts.push({ index: index, target: parseInt(part, 10), current: 0 });
      }
    });

    if (numberParts.length === 0) return;

    var startTime = null;

    function update(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);

      var output = parts.map(function (part, index) {
        for (var i = 0; i < numberParts.length; i++) {
          if (numberParts[i].index === index) {
            var current = Math.round(eased * numberParts[i].target);
            var targetStr = String(numberParts[i].target);
            var currentStr = String(current);
            while (currentStr.length < targetStr.length) {
              currentStr = '0' + currentStr;
            }
            return currentStr;
          }
        }
        return part;
      }).join('');

      element.textContent = output;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    element.textContent = parts.map(function (part) {
      if (/^\d+$/.test(part)) {
        return '0'.repeat(part.length);
      }
      return part;
    }).join('');

    requestAnimationFrame(update);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      animateValue(entry.target);
    });
  }, { threshold: 1 });

  var elements = document.querySelectorAll('[data-gaganyaan-stat-value]');
  elements.forEach(function (el) {
    observer.observe(el);
  });
});
